import OrderPrestataireModalContent from "components/Logistique/LogistiqueOrderDetail/OrderPrestataireModalContent";
import { AppProps } from ".";

function App({ initialData, onSubmit }: AppProps) {
  const {
    expeditionId,
    orderDetail,
    orderServiceProvider,
    serviceProviderZoneIds,
    selectedProductLines,
    qboServiceProviderId
  } = initialData;
  console.log("initialData: ", initialData);

  return (
    <div className="App qbo-style">
      <OrderPrestataireModalContent
        expeditionId={expeditionId}
        orderDetail={orderDetail}
        orderServiceProvider={orderServiceProvider}
        handleSubmitNewSP={onSubmit}
        serviceProviderZoneIds={serviceProviderZoneIds}
        selectedProductLines={selectedProductLines}
        qboServiceProviderId={qboServiceProviderId}
      />
    </div>
  );
}

export default App;
